import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Client } from '../../shared/services/client'
import { DateObj } from '../_models/DateObj';
import { Subject } from 'rxjs';
import { Reports } from '../_models/Reports';

@Injectable()
export class PhoneReportsService {

  private dataTracker = new Subject<any>();
  private statusTracker = new Subject<number>();
  timePeriod = new Subject<any>();

  constructor(
    private http: HttpClient,
    private client: Client
  ) { }

  filteringReportsByPeriod(dateValue: any) {
    if(dateValue.inputStartDate) {
      const currentDateObject: DateObj = {
        from: dateValue.inputStartDate.toISOString().slice(0,10),
        to: dateValue.inputEndDate.toISOString().slice(0,10),
        perPage: dateValue.perPage? dateValue.perPage: 10,
        page: dateValue.page? dateValue.page: 1,
      }
      this.getReportsByPeriod(currentDateObject);
    }
  }

  reportsTracker() {
    return this.dataTracker.asObservable();
  }

  getTestStatusTrack() {
    return this.statusTracker.asObservable();
  }

  getAllReports(obj?: any) {
    this.http.get(this.client.getAllPhoneReports(obj)).subscribe(res => {
        this.dataTracker.next(res);
      });
  }
  private getReportsByPeriod(obj: DateObj) {
    this.http.get(this.client.getPhoneReportsByPeriod(obj)).subscribe(res => {
          this.dataTracker.next(res);
        });
  }

  grtMinDateReports() {
    return this.http.get(this.client.getMinDateOfReportsUrl());
  }

  getStartTest() {
    return this.http.get(this.client.getStartTestPortsUrl());
  }

  getStopTest() {
    return this.http.get(this.client.getStopTestPortsUrl());
  }

  getTestStatus() {
    this.http.get(this.client.getPortTestStatus())
        .subscribe(res => {
          this.statusTracker.next(res['percent_completed']);
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/phone-reports/services/phone-reports.service.ts